import { Component, PLATFORM_ID, HostListener, Inject } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { Router } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { CommonModule } from '@angular/common';
import { WebService } from '../services/web.service';
import { ApidataService } from "../apidata.service";
import { ReactiveFormsModule } from '@angular/forms';
import {  NavigationEnd, RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { RecaptchaModule, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment, GINConstants } from '../../environments/environments';
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ HttpClientModule, CommonModule,CommonModule,ReactiveFormsModule, RouterModule , RecaptchaModule,],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css',
  providers: [ApidataService]
})
export class ForgotPasswordComponent {

  form_email;
  reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  fieldIf: boolean = false;
  color: string = 'black';
  dangerAlerts;
  dangerAlerts2;
  emailNotFound: boolean = false;
  color1;
  authentication_token;
  recaptcha_message = ""
  got_recpatcha : boolean = false;
  captchaResponse: string;

  captchaToken: string | null = null; 
  public nodata: boolean = false;
  constructor(private router: Router,
    private _webservice: WebService,
    @Inject(PLATFORM_ID) private platformID: Object,
    private httpClient: HttpClient,
    private apidata: ApidataService
){this.router.events
  .pipe(filter(event => event instanceof NavigationEnd))
  .subscribe(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });}

  navigateTosignin() {
    this.router.navigate(['/signin']);
  }
  navigateToHome() {
    this.router.navigate(['']);
  }
  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
  resetPassword(event) {
    event.preventDefault();
    this.fieldIf = false;
    $('#dangerAlerts').hide();
    this.form_email = $('#fp_email').val();
    let remember_me = $('#remember_me').val();

    if (
      typeof this.form_email === 'string' &&  this.reg.test(this.form_email) === false
    ) {

      this.showAlert("Please provide the Email.","");
    } else {

        this.apidata.passwordReset(this.form_email).subscribe(
          response => {
            if ( response.contents === -1 || response.message === 'Email not found') {
              this.showAlert("Email Address Not Found.","");

            } else {
              this.emailNotFound = false;
            this.showSuccess("'Email Sent! Please Check Inbox.'","")
            this.resetEmailField();
            }
          },
          (error) => {
            // console.error(error);
          }
        );
    }
  }

  showAlert(message, selector) {
    this.color = '#721c24';
    this.dangerAlerts = message;
    this.fieldIf = true;
    $('#dangerAlerts').show();
    setTimeout(() => {
      $('#dangerAlerts').hide();
      this.fieldIf = false;
    }, 4000);
  }
  showSuccess(message, selector) {
    this.color1 = 'green';
    this.dangerAlerts2 = message;
    this.emailNotFound = true;
    $('#dangerAlerts2').show();
    setTimeout(() => {
      $('#dangerAlerts2').hide();      
      this.emailNotFound = false;
    }, 4000);
  }

  resetEmailField() {
    $('#fp_email').val('');
    $('#fp_email').css("border-color", "#e7e7ec");
  }

  public ngAfterViewInit(): void {
    this.loadTurnstileScript().then(() => this.renderTurnstile());}
////// hidden recaptcha strat

loadTurnstileScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof window['turnstile'] !== 'undefined') {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject('Failed to load Turnstile script');
    document.body.appendChild(script);
  });
}

renderTurnstile(): void {
  if (typeof window['turnstile'] !== 'undefined') {
    window['turnstile'].render('#recaptcha-container', {
      sitekey: environment.CaptchaKey, 
      size: 'normal', 
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
    //  console.log('Turnstile rendered successfully.');
  } else {
    // console.error('Turnstile script not loaded.');
  }
}


handleButtonClick(event: Event): void {
  event.preventDefault(); 

  if (!this.captchaToken) {
   
    this.got_recpatcha = true;
    $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
    $('#dangerAlert').show();
    this.nodata = true;

    setTimeout(() => {
      $('#dangerAlert').hide();
    }, 3000);

    return; 
  }

  this.got_recpatcha = false;
  this.resetPassword(event);
}

onTurnstileSuccess(token: string): void {
  // console.log('Turnstile token received:', token);
  this.captchaToken = token;  
}

onTurnstileError(): void {
  // console.error('Turnstile error occurred.');
  this.captchaToken = null; 
}


///// recaptcha end

}
